import { createFileRoute } from "@tanstack/react-router";
import { BOMExplorer } from "@/components/tabs/BOMExplorer";

export const Route = createFileRoute("/bom/")({
  component: BOMExplorer,
});
